export const itemDropdownPrestasi = [
  {
    text: "Prestasi Terbaru",
    value: 0,
  },
  {
    text: "Prestasi Terdahulu",
    value: 1,
  },
];

export const listKategori = [
  "Pilih Kategori",
  "siswa",
  "orang tua",
  "alumni",
  "publik",
];

export const listSubject = [
  "Pilih Subjek",
  "program belajar",
  "berita mengenai wardaya",
  "kegiatan non-belajar",
  "komunitas dan alumni",
  "lainnya",
];
